import { GOOGLE_MAPS_API_KEY } from 'components/globals';
import { Loader } from 'google-maps';

export type GoogleMapsApi = { maps: typeof google.maps };

let googleMapsPromise: Promise<GoogleMapsApi> | null = null;

/**
 * Loads the Maps JavaScript API once per page and shares the promise. Every
 * consumer must go through this function: the `google-maps` loader registers
 * one global callback, so two Loader instances on one page overwrite each
 * other and the first promise never resolves. The geometry library is
 * included because Street View computes headings with it.
 */
export const loadGoogleMaps = (): Promise<GoogleMapsApi> => {
  googleMapsPromise ??= new Loader(
    process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || GOOGLE_MAPS_API_KEY,
    { libraries: ['geometry'] },
  )
    .load()
    .catch((error: unknown) => {
      googleMapsPromise = null;
      throw error;
    });
  return googleMapsPromise;
};
